// extracted by mini-css-extract-plugin
export default {"settings_container":"settings_container__aZST8","contentContainer":"contentContainer__Kq2HG"};